import { PLAN_KEY } from '../constants'
import { getValueReduxUtil } from '../../../redux'

export function isChallengePlanUtil (plan) {
  return !!getValueReduxUtil(plan, PLAN_KEY.CHALLENGE)
}

export {
  default as getParentIdPlanUtil
} from './get-parent-id'

export {
  default as getOriginalParentIdPlanUtil
} from './get-original-parent-id'

export {
  default as getOrderedEquipmentPlanUtil
} from './get-original-parent-id'

export {
  default as isRecommendedPlanUtil
} from './is-recommended'

export {
  default as isLoggedPlanUtil
} from './is-logged'

export {
  default as hasStartedPlanUtil
} from './has-started'

export {
  default as hasStartedAndNotEndedPlanUtil
} from './has-started-and-not-ended'

export {
  default as getWorkoutsCountPlanUtil
} from './get-workouts-count'

export {
  default as getWorkoutsPlanUtil
} from './get-workouts'

export {
  default as getWeeksCountPlanUtil
} from './get-weeks-count'

export {
  default as getNamePlanUtil
} from './get-name'

export {
  default as getLoggedAtPlanUtil
} from './get-logged-at'

export {
  default as getImageUriPlanUtil
} from './get-image-uri'

export {
  default as getImageFullUriPlanUtil
} from './get-image-full-uri'

export {
  default as getDomainListPathPlanUtil
} from './get-domain-list-path'

export * from './is-author'
export * from './can-edit'
